/**
 * @packageDocumentation
 * @module f1/to
 */

import fold from '../adt/fold';
import { t_rec_arr, t_key } from '../types';

type t_from_fn = <T>(value: T, record: ArrayLike<T> | T[] | t_rec_arr<T>) => t_key;

export interface ToRecord {
  /**
   * Convert array-like or records to a record
   *
   * @public
   * @todo we should support iterables (e.g. Map)
   * @function f1.to.record
   * @param value an array-like or record
   * @example
   *
   * ```ts
   * f1.to.record('id', [{ id: 1 }, { id: 4 }]) => { 1: { id: 1 }, 4: { id: 4 }}
   * ```
   */
  <T>(from_fn: t_from_fn, value: ArrayLike<T> | T[] | t_rec_arr<T> | T | null | undefined): Record<string, T>;
}

/**
 * @see ToRecord
 */
export default <T>(
  from_fn: t_from_fn,
  value: ArrayLike<T> | T[] | t_rec_arr<T> | T | null | undefined
): Record<string, T> => {
  return fold(
    (record, v: T) => {
      record[v[from_fn(v, record)]] = v;
      return record;
    },
    {},
    value as T[]
  );
};
